module.exports = __webpack_public_path__ + "img/cognitive_stimulation.b80419fc.png";